import moment from 'moment';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { getLastRefreshDate } from '../../../../services/cesl-bus/pdlService';
import { getISTDate } from '../../../Shared/common';

const PDLContext = createContext();

export const PDLContextProvider = ({ children }) => {

    const [GlobalFilter, setGlobalFilters] = useState({
        search: [],
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        city: [],
        depot: [],
        contract: []
    });

    useEffect(() => {
        getLastRefreshDate()
            .then(res => {
                let date = moment(res?.lastRefreshDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
                setGlobalFilters(prev => ({
                    ...prev,
                    startDate: getISTDate(date),
                    endDate: getISTDate(date)
                }))
            })
    }, [])

    return (
        <PDLContext.Provider value={{ GlobalFilter, setGlobalFilters }}>
            {children}
        </PDLContext.Provider>
    );
};

export const usePDLContextData = () => useContext(PDLContext);